import { alpha } from "@mui/material/styles";

// ----------------------------------------------------------------------

// SETUP COLORS

export const grey = {
  0: "#FFFFFF",
  100: "#F5F6F7",
  200: "#F4F6F8",
  300: "#DFE3E8",
  400: "#C4CDD5",
  500: "#919EAB",
  600: "#637381",
  700: "#454F5B",
  800: "#212B36",
  900: "#161C24",
};

export const blue = {
  0: "#e6efff",
  300: "#1877F2",
};
// // main: '#06603a',

export const primary = {
  lighter: "#77cd9c",
  light: "#56ab7d",
  main: "#004B49",
  dark: "#004B49",
  darker: "#005129",
  contrastText: "#FFFFFF",
};

export const secondary = {
  lighter: "#EFD6FF",
  light: "#C684FF",
  main: "#8E33FF",
  dark: "#5119B7",
  darker: "#27097A",
  contrastText: "#FFFFFF",
};

export const tagBlack = {
  main: "#000000",
  contrastText: "#FFFFFF",
};

export const tagGrey = {
  main: "#C4CDD5",
  contrastText: "#000000",
};

export const kkoYellow = {
  main: "#ffeb00",
  contrastText: "#000000",
};

export const tagPurple = {
  main: "#F97000", // 신청승낙용 주황색으로 변경
  contrastText: "#FFFFFF",
};
export const tagBlue = {
  main: "#1877F2",
  contrastText: "#FFFFFF",
};
export const tagRed = {
  main: "#FF5630",
  contrastText: "#FFFFFF",
};
export const tagGreen = {
  main: "#13CE66", // 초록색으로 변경 (예약확정용)
  contrastText: "#FFFFFF",
};
export const tagOrange = {
  main: "#FF9800", // 주황색 추가
  contrastText: "#FFFFFF",
};
export const tagDarkGreen = {
  main: "#004B49",
  contrastText: "#FFFFFF",
};

export const info = {
  lighter: "#CAFDF5",
  light: "#61F3F3",
  main: "#00B8D9",
  dark: "#006C9C",
  darker: "#003768",
  contrastText: "#FFFFFF",
};

export const success = {
  lighter: "#D0ECFE",
  light: "#73BAFB",
  main: "#1877F2",
  dark: "#0C44AE",
  darker: "#042174",
  contrastText: "#FFFFFF",
};

export const warning = {
  lighter: "#FFF5CC",
  light: "#FFD666",
  main: "#FFAB00",
  dark: "#B76E00",
  darker: "#7A4100",
  contrastText: grey[800],
};

export const error = {
  lighter: "#FFE9D5",
  light: "#FFAC82",
  main: "#FF5630",
  dark: "#B71D18",
  darker: "#7A0916",
  contrastText: "#FFFFFF",
};

export const common = {
  darkGrey: "#4d4d4d",
  black: "#000000",
  white: "#F5F6F7",
  offWhite: "#FAF9F6",
};

export const action = {
  hover: alpha(grey[500], 0.08),
  selected: alpha(grey[500], 0.16),
  disabled: alpha(grey[500], 0.8),
  disabledBackground: alpha(grey[500], 0.24),
  focus: alpha(grey[500], 0.24),
  hoverOpacity: 0.08,
  disabledOpacity: 0.48,
};

const base = {
  tagDarkGreen,
  kkoYellow,
  tagPurple,
  tagBlack,
  tagGrey,
  tagGreen,
  tagBlue,
  tagRed,
  tagOrange,
  primary,
  secondary,
  info,
  success,
  warning,
  error,
  grey,
  blue,
  common,
  divider: alpha(grey[500], 0.2),
  action,
};

// ----------------------------------------------------------------------

export function palette() {
  return {
    ...base,
    mode: "light",
    text: {
      primary: grey[800],
      secondary: grey[600],
      disabled: grey[500],
    },
    background: {
      paper: "#FFFFFF",
      default: grey[100],
      neutral: grey[300],
    },
    action: {
      ...base.action,
      active: grey[600],
    },
  };
}
